export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path !== from.path && process.client) {
    window.scrollTo({ behavior: 'auto', left: 0, top: 0 })
  }
})
